export const useLastTimestampOfWeek = () => {
  const lastTimestampOfWeek = new Date();
  lastTimestampOfWeek.setHours(23, 59, 59, 999);
  lastTimestampOfWeek.setDate(
    lastTimestampOfWeek.getDate() + (6 - lastTimestampOfWeek.getDay()) + 5
  );

  return lastTimestampOfWeek.getTime();
};
